/**
 * PERS WS-Relay Shared Types
 *
 * Type-safe WebSocket communication types for the PERS event relay system.
 *
 * @version 1.2.0
 */
// =============================================================================
// HELPER FUNCTIONS (TYPE GUARDS)
// =============================================================================
/**
 * Type guard for server messages
 */
export function isServerMessage(data) {
    return (typeof data === 'object' &&
        data !== null &&
        'type' in data &&
        'timestamp' in data);
}
/**
 * Type guard for event messages
 */
export function isEventMessage(msg) {
    return msg.type === 'event';
}
/**
 * Type guard for connected messages
 */
export function isConnectedMessage(msg) {
    return msg.type === 'connected';
}
/**
 * Type guard for subscribed messages
 */
export function isSubscribedMessage(msg) {
    return msg.type === 'subscribed';
}
/**
 * Type guard for unsubscribed messages
 */
export function isUnsubscribedMessage(msg) {
    return msg.type === 'unsubscribed';
}
/**
 * Type guard for error messages
 */
export function isErrorMessage(msg) {
    return msg.type === 'error';
}
/**
 * Type guard for ping messages
 */
export function isPingMessage(msg) {
    return msg.type === 'ping';
}
//# sourceMappingURL=ws-relay.types.js.map